export default __webpack_public_path__ + "images/default.svg?7e8a82119a5640bde09b542289df7446";